/*
 * @Author: Json Chen
 * @Date: 2021-06-17 16:11:22
 * @LastEditTime: 2021-06-25 13:45:09
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/product/index.ts
 */

import { get, post } from '@/src/tools/server';

export const setProductSetting = (body: any) => {
  return post<any>(`/portal/setting/store/productSetting`, body, {});
};

export const getProductSetting = () => {
  return get<any>(`/portal/setting/store/productSetting`, {});
};

export const getCheckPriceTier = (uuid: string) => {
  return get<any>(
    `/portal/setting/store/productSetting/priceTier/deleted/validate/${uuid}`,
    {},
  );
};
